import { render, staticRenderFns } from "./PaymentDocuments.vue?vue&type=template&id=9b0a1900"
import script from "./PaymentDocuments.vue?vue&type=script&lang=js"
export * from "./PaymentDocuments.vue?vue&type=script&lang=js"
import style0 from "./PaymentDocuments.vue?vue&type=style&index=0&id=9b0a1900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports